import React, { FC, ReactNode } from 'react';
import { NgCard, NgCardContent, NgCardTitle } from '../NgCard/NgCard';
import styled from "styled-components";

interface NgSectionCardProps {
  title: string;
  headerContent?: ReactNode;
  children?: ReactNode;
}

const StyledHeader = styled.div`
  display: flex;
  justify-content: space-between;
`

export const NgSectionCard: FC<NgSectionCardProps> = ({ children, headerContent = null, title }) => {
  return (
    <NgCard>
      <NgCardContent>
        <StyledHeader>
          <NgCardTitle title={title} />
          {headerContent}
        </StyledHeader>

        {children}
      </NgCardContent>
    </NgCard>
  );
};
